export const readBuildId = (raw: string | undefined): string | null => {
  const trimmed = raw?.trim() ?? ''
  return trimmed === '' ? null : trimmed
}

export const APP_BUILD_ID = readBuildId(import.meta.env.VITE_APP_BUILD_ID)
